module.exports = __webpack_public_path__ + "static/media/oberflex-aniegret7-2560x1440.c3ba06e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegret7-2560x1440.jpg
// module id = 977
// module chunks = 37